import { MAX_STATUS_REASONS } from '../../../../../../DataRoom/constants';
import {
    PROVISIONAL_FILE_STATUS_CHIP,
    PROVISIONAL_FILE_STATUS_MESSAGE,
    PROVISIONAL_FILE_UNKNOWN_STATUS_CHIP,
    PROVISIONAL_FILE_UNKNOWN_STATUS_MESSAGE,
    PROVISIONAL_FILE_VIEW_STATUS,
} from './constants';
import { ProvisionalFileItem } from './types';

/** List-row chip for a non-viewable file: the engine's `docStatus.chip` when present, else the legacy label. */
export const getProvisionalFileStatusChip = (file: ProvisionalFileItem): string | undefined => {
    if (file.viewStatus === PROVISIONAL_FILE_VIEW_STATUS.VIEWABLE) return undefined;
    return file.docStatus?.chip ?? PROVISIONAL_FILE_STATUS_CHIP[file.viewStatus] ?? PROVISIONAL_FILE_UNKNOWN_STATUS_CHIP;
};

/** Note for a non-viewable file: the engine's `docStatus.message` when present, else the legacy copy. */
export const getProvisionalFileStatusMessage = (file: ProvisionalFileItem): string =>
    file.docStatus?.message ?? PROVISIONAL_FILE_STATUS_MESSAGE[file.viewStatus] ?? PROVISIONAL_FILE_UNKNOWN_STATUS_MESSAGE;

/** Reason lines under a non-viewable file's note: the engine's `docStatus.details` messages (the legacy fallback has none). */
export const getProvisionalFileStatusDetails = (file: ProvisionalFileItem): string[] => {
    if (file.viewStatus === PROVISIONAL_FILE_VIEW_STATUS.VIEWABLE || !file.docStatus?.message) return [];
    return file.docStatus.details?.slice(0, MAX_STATUS_REASONS).map((detail) => detail.message) ?? [];
};
